export default function isVillage(place: string) {
	if (!place) return place;
	return place.includes("k.") || place.includes("kaimas");
}
